// extracted by mini-css-extract-plugin
export default {"lexiModal":"LexiModal_lexiModal__Qqbti","okButton":"LexiModal_okButton__66Sgk"};